
const apiLoaderReducer = (state = false, action) => {
    switch(action.type){
        case 'API_LOADER_START': 
            return state = true;
        case 'API_LOADER_STOP':
              return state = false; 
        default:
              return state;

    }
};

export default apiLoaderReducer;